<template>
  <div class="report-check">
    <div class="data-content">
      <div class="table-head">
        <div class="table-title">
          <span style="font-weight: bold">短信验证码列表</span>
        </div>
        <div>
            <Input
                v-model="filterData.phone_number"
                maxlength="11"
                placeholder="手机号码"
                clearable
                style="min-width: 80px; width:150px; margin-right: 10px;"/>
            <Button @click="getData()">搜索</Button>
        </div>
      </div>
      <Table :columns="columns" :data="changeDataList" @on-selection-change="selected">
        <template slot-scope="{ row, index }" slot="id">
          <span>{{ row.id }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="created_at">
          <span>{{ row.created_at }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="phone_number_area">
          <span>{{ row.area_code }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="phone_number">
          <span>{{ row.phone }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="reason_title">
          <span>{{ row.reason_title }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="random_code">
          <span>{{ row.random_code }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="response">
          <span>{{ row.response }}</span>
        </template>

      </Table>
    </div>
  </div>
</template>

<script>
import apis from "../../http/api";
import commonApi from "../../utils/commonapi";

export default {
  name: "ReportCheck",
  components: {},
  watch: {
  },
  data() {
    return {
      filterData: {
        phone_number:null,
      },
      selectedItem: [],
      selectedId: [],
      dataList: [],
      avatar: null,  // 被举报人头像
      columns: [
        {
          title: 'id',
          slot: 'id',
          width:100,
          align: 'center'
        },
        {
          title: '创建时间',
          slot: 'created_at',
          width: 200,
          align: 'center'
        },
        {
          title: '区号',
          slot: 'phone_number_area',
          width: 120,
          align: 'center'
        },
        {
          title: '手机号',
          slot: 'phone_number',
          width: 200,
          align: 'center'
        },
        {
          title: '发送类型',
          slot: 'reason_title',
          width: 120,
          align: 'center'
        },
        {
          title: '短信验证码',
          slot: 'random_code',
          width: 120,
          align: 'center'
        },
        {
          title: '备注',
          slot: 'response',
          align: 'center'
        }
      ],
    }
  },
  created() {
  },
  methods: {
    getData() {
      if(this.filterData.phone_number == undefined){
          alert('请输入手机号码')
          return 
      }
      let params = {
        phone_number: this.filterData.phone_number
      };
      apis.co_time_tool_user_captcha(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          var list = data
          console.log(JSON.stringify(list))
          this.dataList =list;
          commonApi.recordFromOperationToolCaptcha(0, this.filterData.phone_number)
          if(list.length == 0){
              this.$Message.success('暂无短信发送记录！')
          }
        }else{
          alert(msg)
        }
      }).catch(err => {
        alert("接口异常")
      })
    },
    selected(selecttion) {
      this.selectedId = [];
      this.selectedItem = selecttion;
      selecttion.forEach(item => {
        this.selectedId.push(item.id)
      })
      console.log(this.selectedId)
    },
  },
  computed: {
    changeDataList() {
        return this.dataList.map(item => {
          return item
        })
    }
  },
  filters: {
  }
}
</script>

<style scoped>
.report-check {
  margin: 10px;
}

.clickable-span {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;
}

.text-center {
  text-align: center;
}

.table-head {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
}

.table-title {
  align-self: center;
}

.modal1-div {
  margin-bottom: 10px;
}

.info-pop {
  white-space: pre-wrap;
}
</style>
